module.exports = __webpack_public_path__ + "static/media/Ikon.58211dfa.svg";